export default __webpack_public_path__ + "static/media/a024-startup-5.d3e60ea2.svg";